:host {
  --uui-search-max-width: 100%;
  --uui-search-container-width: 100%;
  --uui-tree-select-header-margin-bottom: 20px;
  --uui-tree-select-item-max-width: 200px;
  --uui-tree-max-height: 600px;
  --scroll-color: var(--uui-gray-02);
  --scroll-background-color: var(--uui-gray-05);
}

.uui-tree-select-search-container {
  padding: 0 10px;
}

.uui-tree-select-options-container {
  padding: 0 10px;
  padding-bottom: 10px;
}

.uui-tree-select-header-container {
  width: var(--uui-search-container-width);
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  /* margin-bottom: var(--uui-tree-select-header-margin-bottom); */
  padding: 10px;
}

.uui-tree-select-header {
  display: flex;
  border-bottom: none;
}

.uui-tree-select-header-active {
  display: flex;
  border-bottom: 1px solid var(--uui-teal-dark-active);
}

.uui-button-header-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.uui-icon-header-icon {
  margin-left: var(--uui-x-small-padding);
}

.active {
  color: var(--uui-teal-dark-active);
}

.divider {
  margin-top: 10px;
  width: 100%;
  border-bottom: 1px solid var(--uui-gray-06);
}

.uui-tree-select-items-container {
  padding: 0 10px;
  padding-bottom: 20px;
  max-height: var(--uui-tree-max-height);
  overflow-y: auto;
  /* firefox */
  scrollbar-color: var(--scroll-color) var(--scroll-background-color);
  scrollbar-width: thin; 
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px var(--scroll-background-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--scroll-color);
  border-radius: 4px;
}

.pipe {
  margin: 0 8px;
}